"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1597))
 * @lastsynced 2023-07-10T21:45:00.094Z
 */
export const SaleTag = createSVGIcon(
  <>
    <path
      d="M21.1217 15.6669L15.6668 21.1217C15.5474 21.2412 15.4057 21.336 15.2496 21.4006C15.0936 21.4653 14.9263 21.4986 14.7574 21.4986C14.5885 21.4986 14.4212 21.4653 14.2652 21.4006C14.1091 21.336 13.9674 21.2412 13.848 21.1217L2.68969 9.96343C2.62501 9.8986 2.5749 9.82072 2.54268 9.735C2.51046 9.64928 2.49687 9.55767 2.50283 9.46629L2.90054 3.50058C2.91099 3.34488 2.97755 3.19826 3.08789 3.08792C3.19823 2.97758 3.34485 2.91102 3.50054 2.90057L9.46626 2.50286C9.55764 2.4969 9.64925 2.51049 9.73497 2.54271C9.82069 2.57493 9.89856 2.62504 9.9634 2.68972L21.1217 13.848C21.2412 13.9674 21.3359 14.1092 21.4006 14.2652C21.4653 14.4213 21.4986 14.5885 21.4986 14.7574C21.4986 14.9263 21.4653 15.0936 21.4006 15.2496C21.3359 15.4057 21.2412 15.5475 21.1217 15.6669V15.6669Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.23242 8.08972C7.23242 8.31705 7.32273 8.53506 7.48347 8.69581C7.64422 8.85655 7.86224 8.94686 8.08956 8.94686C8.31689 8.94686 8.53491 8.85655 8.69566 8.69581C8.8564 8.53506 8.94671 8.31705 8.94671 8.08972C8.94671 7.86239 8.8564 7.64437 8.69566 7.48363C8.53491 7.32288 8.31689 7.23257 8.08956 7.23257C7.86224 7.23257 7.64422 7.32288 7.48347 7.48363C7.32273 7.64437 7.23242 7.86239 7.23242 8.08972Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "SaleTag",
  {
    viewBox: "0 0 24 24",
    titleAccess: "SaleTag",
    fill: "none",
    color: Core.icon.default,
  }
);
